import apiClient from "./apiClient";

export const assetService = {
  // view: "current" (default) | "history" | "all"
  // -> { data: MyAssignment[], pendingAcknowledgement: number }
  getMyAssignments: ({ view = "current" } = {}) =>
    apiClient.get("/asset-assignments/my", { params: { view } }),

  // "I received this". Safe to repeat.
  acknowledge: (id) => apiClient.patch(`/asset-assignments/${id}/acknowledge`),

  // Own employeeId only (clearance card). -> { employee, clearance: { canClear, unreturned, lost }, active, history }
  getEmployeeAssets: (employeeId) =>
    apiClient.get(`/asset-assignments/employee/${employeeId}`),
};
